import { render, staticRenderFns } from "./PurchaseEvents.vue?vue&type=template&id=daaaa282&scoped=true"
import script from "./PurchaseEvents.vue?vue&type=script&lang=js"
export * from "./PurchaseEvents.vue?vue&type=script&lang=js"
import style0 from "./PurchaseEvents.vue?vue&type=style&index=0&id=daaaa282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaaa282",
  null
  
)

export default component.exports